export const getSentryEnvironment = () => {
  // Used to determine the Sentry environment based on the provided VITE_APP_ENV variable.
  if (process.env.VITE_APP_USING_RUNNER) {
    return 'CI';
  }
  if (process.env.VITE_APP_ENV === 'prod') {
    return 'PROD';
  }
  if (process.env.VITE_APP_BACKEND_URL?.includes('api.test.')) {
    return 'TEST 1';
  }
  if (process.env.VITE_APP_BACKEND_URL?.includes('api.test2.')) {
    return 'TEST 2';
  }
  if (process.env.VITE_APP_BACKEND_URL?.includes('api.uat')) {
    return 'UAT';
  }
  return 'DEV';
};
